import { useAuth } from '../contexts/AuthContext'

// Permissões dos cadastros, num lugar só. Espelha routes.go: criar e editar são de
// engineer, apagar é de admin (apagar um cadastro referenciado quebra histórico).
//
// ATENÇÃO ao que isto NÃO é: não é a barreira de segurança. Quem recusa é o backend, em
// toda rota, e continuará recusando se alguém chamar a API direto. Esconder ou
// desabilitar aqui serve para a interface não prometer o que vai falhar com 403, e para
// a trilha de auditoria não encher de recusas de gente legítima clicando no que a
// própria tela ofereceu.
export function useRegistryPerms() {
  const { can } = useAuth()
  return {
    mayEdit: can('engineer'),
    mayDelete: can('admin'),
    // Motivo mostrado no tooltip do controle desabilitado. Desabilitar dizendo por quê
    // é melhor que sumir: o botão que some sem explicação vira chamado de suporte.
    reasonEdit: 'admin:perms.needs_engineer',
    reasonDelete: 'admin:perms.needs_admin',
  }
}
